var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide"},on:{"after-enter":_vm.afterEnter,"before-leave":_vm.beforeLeave}},[(_vm.isLoading)?_c('div',{class:_vm.loaderClass}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }